import { render, staticRenderFns } from "./WorkReport.vue?vue&type=template&id=bb0ea4b0&scoped=true&"
import script from "./WorkReport.vue?vue&type=script&lang=ts&"
export * from "./WorkReport.vue?vue&type=script&lang=ts&"
import style0 from "./WorkReport.vue?vue&type=style&index=0&id=bb0ea4b0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0ea4b0",
  null
  
)

export default component.exports